<template>
  <span class="multiselect-wrapper">
    <multiselect
      :value="selectedItem"
      track-by="definition"
      :placeholder="$t('task.priority.text')"
      :options="options"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      @select="itemSelected($event)"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <task-priority :priority="option.definition" size="13" />
      </template>
      <template slot="option" slot-scope="{ option }">
        <task-priority :priority="option.definition" size="13" />
      </template>
    </multiselect>
  </span>
</template>

<script>
import { priorityOptions, resolvePriorities } from "@/modules/task/task-settings";

export default {
  props: ["selected"],
  data() {
    return {
      selectedItem: undefined,
    };
  },
  computed: {
    options() {
      // TKP-119: organizasyonun öncelik kayıtları (özel dahil); kayıt yoksa sistem varsayılanları
      const language = this.account.language;
      return priorityOptions(resolvePriorities(this.$store.getters["taskSettings/priorities"], language, (k) => this.$t(k)), language);
    },
    account() {
      return this.$store.getters["user/account"];
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(v) {
        this.selectedItem = this.options.find((i) => i.definition == v) || 2;
      },
    },
  },
  mounted() {},
  methods: {
    itemSelected(item) {
      this.selectedItem = item;
      if (item) {
        this.$emit("onSelect", item.definition);
      } else {
        this.$emit("onSelect", "MEDIUM");
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
</style>
